const A = { CRGA: "CRGA" };
export {
  A as AGENT_TYPES
};
//# sourceMappingURL=AgentType.js.map
